// Polyfill for forEach IE11

function forEach() {
    if (window.NodeList && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = function iterate(callback, thisArg) {
            const argument = thisArg || window;
            for (let i = 0; i < this.length; i++) {
                callback.call(argument, this[i], i, this);
            }
        };
    }
}

export default forEach;



// WEBPACK FOOTER //
// ./src/Will/WebsiteBundle/Resources/ui/js/forEach.js